import { useNavigate } from '@report/router';
import { PageNotFound } from '@shared/components';

export default function NotFoundPage() {
  const navigate = useNavigate();
  const handleBackToHome = () => {
    navigate('/');
  };

  return <PageNotFound onBackToHome={handleBackToHome} />;
}
